/* eslint-disable react/forbid-prop-types */
import React from 'react';
import Lottie from 'react-lottie';
import loadingData from './loading.json';
// import './styles.css';

export default function Load({ size = 'medium' }) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: loadingData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const dimensions = {
    small: {
      height: 200,
      width: 200,
    },
    medium: {
      height: 400,
      width: 400,
    },
    large: {
      height: 600,
      width: 600,
    },
    xlarge: {
      height: 800,
      width: 800,
    },
  }[size];

  return (
    <div className="animation">
      <Lottie
        style={{margin:0}}
        options={defaultOptions}
        height={dimensions.height}
        width={dimensions.width}
      />
    </div>

  );
}
